export default "/b554e21ed8a659b822597c92967d1f4c2aa51bb5/c149c2995e67c98d8198109bf15793c7.svg";